export enum NotificationTypes {
  SUCCESS = "success",
  INFO = 'info',
  ERROR = 'error',
  WARNING = 'warning',
}
